import { EndpointMockDescription, MockOptions } from '@cp-shared-19/frontend-storybook-extensions';
import { DefaultBusinessMarketApiError, DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getContractsEndpoint } from 'cpfr-common';
import { CreditContractsWithMixedEntries } from '../ExampleData';

const contractsMockOptions: MockOptions<DefaultBusinessMarketApiErrorCode> = {
    Success: {
        status: 200,
        responseBody: CreditContractsWithMixedEntries,
    },
    'Business Error': DefaultBusinessMarketApiError,
    'Unexpected/Connection Error': {
        status: 500,
    },
};
export const ContractsMock: EndpointMockDescription<DefaultBusinessMarketApiErrorCode> = {
    name: 'Contract response',
    method: 'get',
    defaultMockOption: 'Success',
    mockOptions: contractsMockOptions,
    url: getContractsEndpoint(),
};
